import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { TextLandingPage } from './components/TextLandingPage';
import { TwilioCompliancePage } from './components/TwilioCompliancePage';
import { MainLayout } from './components/layout/MainLayout';
import { Dashboard } from './pages/Dashboard';
import { Transcriptions } from './pages/Transcriptions';
import { TranscriptionDetail } from './pages/TranscriptionDetail';
import { BatchProcessing } from './pages/BatchProcessing';
import { History } from './pages/History';
import { Settings } from './pages/Settings';
import { UserProvider, useUser } from './contexts/UserContext';
import { FeaturesPage } from './components/FeaturesPage';
import { RelationshipLandingPage } from './components/RelationshipLandingPage';
import { Search } from './pages/Search';
import { ChatThreadPage } from './pages/ChatThread';
// ScrollToTop component - scrolls to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  useEffect(() => {
    // Check if viewport meta tag exists
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      // Create and append viewport meta tag if it doesn't exist
      viewportMeta = document.createElement('meta');
      viewportMeta.name = 'viewport';
      viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
      document.head.appendChild(viewportMeta);
    } else {
      // Update existing viewport meta tag
      viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    }
  }, []);
  return <BrowserRouter data-id="element-0">
      <UserProvider data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <AppRoutes data-id="element-3" />
      </UserProvider>
    </BrowserRouter>;
}
function AppRoutes() {
  const {
    session,
    signOut
  } = useUser();
  const navigate = useNavigate();
  const handleLogout = async () => {
    await signOut();
    navigate('/');
  };
  return <Routes data-id="element-4">
      {/* Public routes - no auth required */}
      <Route path="/" element={<LandingPage data-id="element-6" />} data-id="element-5" />
      <Route path="/text" element={<TextLandingPage data-id="element-8" />} data-id="element-7" />
      <Route path="/features" element={<FeaturesPage data-id="element-10" />} data-id="element-9" />
      <Route path="/text/compliance" element={<TwilioCompliancePage data-id="element-12" />} data-id="element-11" />
      <Route path="/relationships" element={<RelationshipLandingPage data-id="element-14" />} data-id="element-13" />

      {/* Public transcript view */}
      <Route path="/v/:id" element={<TranscriptionDetail data-id="element-16" />} data-id="element-15" />

      {/* Public chat view - accessed via SMS link */}
      <Route path="/chat/:taskId" element={<ChatThreadPage data-id="element-18" />} data-id="element-17" />

      {/* Public app routes - discovery/browse (no auth required) */}
      <Route path="/app" element={<MainLayout onLogout={handleLogout} data-id="element-20" />} data-id="element-19">
        <Route index element={<Dashboard data-id="element-22" />} data-id="element-21" />
        <Route path="transcriptions" data-id="element-23">
          <Route index element={<Transcriptions data-id="element-25" />} data-id="element-24" />
          <Route path=":id" element={<TranscriptionDetail data-id="element-27" />} data-id="element-26" />
        </Route>
        <Route path="search" element={<Search data-id="element-29" />} data-id="element-28" />
      </Route>

      {/* Authenticated routes - require phone-based auth */}
      <Route path="/app/me" element={session ? <MainLayout onLogout={handleLogout} data-id="element-31" /> : <Navigate to="/" data-id="element-32" />} data-id="element-30">
        <Route index element={<Dashboard data-id="element-34" />} data-id="element-33" />
        <Route path="history" element={<History data-id="element-36" />} data-id="element-35" />
        <Route path="batch" element={<BatchProcessing data-id="element-38" />} data-id="element-37" />
        <Route path="settings" element={<Settings data-id="element-40" />} data-id="element-39" />
      </Route>

      <Route path="*" element={<Navigate to="/" data-id="element-42" />} data-id="element-41" />
    </Routes>;
}